module.exports = __webpack_public_path__ + "static/media/transfer.af2b4703.png";